import { string } from 'yup'
import { safify } from '../utils/safify'

export const caption = string()
  .default('')
  .meta({
    label: 'Post caption',
    placeholder: 'Write your own caption',
    rows: 8,
  })
  .transform(safify)
  .required()
